export const SITE_URL = "https://clearchoicecs.com.au";

export function toAbsoluteUrl(path = "") {
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
}
